import React, { useEffect, useState } from 'react';
import { Modal, Input, Select } from 'antd';
import { Account, AccountLevel } from '../../../Modules/Account/Model/Account';
import { levelKor, creatableLevels } from '../../../Utils/permission';

interface Props {
  currentUserGrade: AccountLevel;
  account: Account | null;
  open: boolean;
  onClose: () => void;
  onSubmit: (dto: Partial<Account>) => void;
}

const { Option } = Select;

const AccountEditModal = ({ currentUserGrade, account, open, onClose, onSubmit }: Props) => {
  const [form, setForm] = useState<Partial<Account>>({});

  useEffect(() => {
    if (!account) return;
    // 등급은 어드민만 수정 가능하므로, 비-어드민은 form에 grade를 담지 않음(실수로 전송 방지)
    if (currentUserGrade === 'ADMIN') {
      setForm({ name: account.name, grade: account.grade, memo: account.memo });
    } else {
      setForm({ name: account.name, memo: account.memo });
    }
  }, [account]);

  if (!account) return null;

  const gradeOptions =
    currentUserGrade === 'ADMIN' && creatableLevels(currentUserGrade).includes(account.grade)
      ? creatableLevels(currentUserGrade)
      : [];

  return (
    <Modal title="계정 수정" open={open} onCancel={onClose}
      onOk={() => {
        const dto: Partial<Account> = { ...form };
        if (currentUserGrade !== 'ADMIN') delete (dto as any).grade;
        onSubmit(dto);
      }} okText="수정">
      <Input placeholder="이름" value={form.name}
        onChange={e => setForm({ ...form, name: e.target.value })} />
      {/* 등급 수정은 어드민만 */}
      {gradeOptions.length > 0 && (
        <Select value={form.grade} style={{ width: '100%', marginTop: 8 }}
          onChange={(v) => setForm({ ...form, grade: v as AccountLevel })}>
          {gradeOptions.map(l => <Option key={l} value={l}>{levelKor[l]}</Option>)}
        </Select>
      )}
      <Input.TextArea rows={4} placeholder="메모" style={{ marginTop: 8 }}
        value={form.memo} onChange={e => setForm({ ...form, memo: e.target.value })} />
    </Modal>
  );
};

export default AccountEditModal;
